<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
	name:'app',
}
</script>
<style lang="scss">
@import "~@/assets/css/app.min.css";
@import "~@/assets/css/yfBefore_style.css";
@import "~@/assets/css/yfAfter_style.css";
@import "~@/assets/css/icons.min.css";

html,body,#app{
	min-height: 100%;
}
ul{
	list-style: none;
	padding-left: 0px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
}

label {
  margin-bottom: 0px;
}
.multi-line-ellipsis{
	overflow: hidden;
	text-overflow: ellipsis;//将文本溢出显示为...
	display: -webkit-box;
	-webkit-line-clamp: 3;//设置在第几行显示...
	-webkit-box-orient: vertical;
}

.ellipsis{
	width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.el-table__body tr.current-row>td{
	background-color: #409eff !important;
	color: #FFFFFF !important;
}
.el-time-spinner__list::after, .el-time-spinner__list::before{
	height: 73px !important;
}
.el-time-spinner__item{
	text-align: center;
}
// 解决elementui表格错位
.el-table th.gutter {
  display: table-cell !important;
}

.el-table colgroup.gutter {
  display: table-cell !important;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.el-table td{
	text-align: center !important;
}
.mb20{
	margin-bottom: 20px;
}
</style>
